import { IonCard, IonIcon } from "@ionic/react";
import { chevronForward } from "ionicons/icons";
import { useHistory } from "react-router-dom";
import UserName from "./UserName";
import BotAvatar from "./BotAvatar";
import { useAuthStore } from "../stores/auth.store";
import LobbyInfo from "./LobbyInfo";
import { useUsersStore } from "../stores/users.store";

interface LobbyCardProps {
  lobby: any;
  join?: boolean;
  routerLink?: string;
  selectionMode?: boolean;
  showPlacings?: boolean;
  showJoinLobby?: () => void;
  setSelectedLobby?: (lobby: any) => void;
  setShowLobby?: (show: boolean) => void;
}

// TODO: Different filters for future and past lobbies
const LobbyCard: React.FC<LobbyCardProps> = ({
  lobby,
  join,
  routerLink,
  selectionMode,
  showPlacings,
  showJoinLobby,
  setSelectedLobby,
  setShowLobby
}) => {
  const uid = useAuthStore(state => state.user?.uid);
  const quoCoin = useUsersStore(state => state.user?.quoCoin) ?? 0;
  const history = useHistory();

  if (!lobby) return null;

  return (
    <IonCard
      button
      disabled={selectionMode && lobby?.buyIn > quoCoin}
      className="bg-primary-70 text-white"
      onClick={() => {
        if (!routerLink) return;
        if (selectionMode) {
          setSelectedLobby && setSelectedLobby(lobby);
          if (join) {
            showJoinLobby && showJoinLobby();
          } else {
            setShowLobby && setShowLobby(true);
          }
        } else {
          routerLink && history.push(routerLink);
        }
      }}
    >
      <div>
        <div className="p-4 flex justify-between items-center">
          <div className="text-lg font-bold">
            {lobby.name}
            <div>
              <UserName userId={lobby.administrators[0]} />
            </div>
          </div>

          {routerLink && (
            <div className="bg-primary-50 p-2 rounded-lg">
              <IonIcon icon={chevronForward} className="text-xl" />
            </div>
          )}
        </div>
        <LobbyInfo lobby={lobby} />
        {showPlacings && (
          <div className="bg-primary-80 px-4 py-2 text-white">
            <div className="text-lg">Current Placings</div>
            <div className="flex flex-row p-2">
              {lobby?.standings
                ?.slice(0, 6)
                .map((standing: any, index: number) => {
                  return (
                    <div
                      key={standing?.botId}
                      className={`flex flex-col px-1 mr-1  ${
                        standing?.user === uid && "bg-primary-60 rounded-lg"
                      }`}
                    >
                      <div className="text-xs font-bold">{index + 1}</div>
                      <BotAvatar small img={standing?.img} />
                      <div
                        className={`text-xs font-bold mx-auto pt-1 ${
                          standing?.profit < 0
                            ? "text-red-400"
                            : "text-green-400"
                        }`}
                      >
                        {standing?.profit?.toFixed(2)}%
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </IonCard>
  );
};

export default LobbyCard;
